import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_EDIT_PRODUCT_TIMELINE } from "../../../config/api";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
// import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const editInvestmentTimeline = createAsyncThunk(
  "editInvestmentTimeline/PATCH",
  async ({ payload, timeline_id, investment_id, cb, failed }) => {
    try {
      const { data } = await Client({
        method: "PATCH",
        path: `${API_EDIT_PRODUCT_TIMELINE}${timeline_id}/${investment_id}`,
        data: payload,
      });
      toast.success("Timeline updated successfully");
      cb(data?.data);
      return data?.data;
    } catch (error) {
      failed();
      const msg = proccessErrorMessage(error);
      toast.error(msg);
    }
  }
);
